import { FEATURE_SPATIAL_LAYERS_SUMMARY } from '@rsos/capstone/src/constants/capabilities';
import type { PsapState } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';

/**
 * Function to determine if the current user's authority has the
 * `feature_spatial_layers_summary` capability turned on
 */
function isSpatialLayersSummaryEnabled(psaps: PsapState): boolean {
  return !!psaps.currentPSAP?.activeCapabilities?.[
    FEATURE_SPATIAL_LAYERS_SUMMARY
  ];
}

export default isSpatialLayersSummaryEnabled;
